import { Component } from '@angular/core';
import { DataserviceService } from '../dataservice.service';

@Component({
  selector: 'app-training-list',
  templateUrl: './training-list.component.html',
  styleUrl: './training-list.component.css'
})
export class TrainingListComponent {

  trainingList: any = [];
  folders: any = [];
  panels: any = [];
  isLoading: boolean = false;

  constructor(
    private data: DataserviceService
  ) {}

  ngOnInit() {
    this.getFolders();
  }

  getFolders() {
    this.isLoading = true;
    this.data.getData(`training/folders`)
      .subscribe({
        next: (res: any) => {
          this.folders = res;
          this.getTrainings();
        }
      })
  }

  getTrainings() {
    this.isLoading = true;
    this.data.getData('training/training-list')
      .subscribe({
        next: (res: any) => {
          console.log(res.data)
          this.trainingList = res.data;

          this.folders = this.folders.map((folder: any) => ({
            ...folder,
            training: this.trainingList.filter((t: any) => t.folder_id === folder.id),
            expand: false
          }));


          this.panels = this.folders.map((folder: any) => ({
            name: folder.name,
            active: folder.expand, 
            disabled: false,
            training: folder.training,
            crm_id: folder.crm_id, 
            folder_id: folder.id 
          }));


          this.isLoading = false;
        }
      })
  }

  openFile(t: any): void {
    window.open(t.link, '_blank');
  }

}
